/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { NetSuiteCredentials } from "./NetSuiteCredentials";
import {
  NetSuiteCredentialsFromJSON,
  NetSuiteCredentialsFromJSONTyped,
  NetSuiteCredentialsToJSON,
  NetSuiteCredentialsToJSONTyped,
} from "./NetSuiteCredentials";

/**
 *
 * @export
 * @interface TestNetSuiteConnectionRequest
 */
export interface TestNetSuiteConnectionRequest {
  /**
   *
   * @type {string}
   * @memberof TestNetSuiteConnectionRequest
   */
  accountId: string;
  /**
   *
   * @type {NetSuiteCredentials}
   * @memberof TestNetSuiteConnectionRequest
   */
  credentials: NetSuiteCredentials;
}

/**
 * Check if a given object implements the TestNetSuiteConnectionRequest interface.
 */
export function instanceOfTestNetSuiteConnectionRequest(
  value: object,
): value is TestNetSuiteConnectionRequest {
  if (!("accountId" in value) || value["accountId"] === undefined) return false;
  if (!("credentials" in value) || value["credentials"] === undefined)
    return false;
  return true;
}

export function TestNetSuiteConnectionRequestFromJSON(
  json: any,
): TestNetSuiteConnectionRequest {
  return TestNetSuiteConnectionRequestFromJSONTyped(json, false);
}

export function TestNetSuiteConnectionRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TestNetSuiteConnectionRequest {
  if (json == null) {
    return json;
  }
  return {
    accountId: json["accountId"],
    credentials: NetSuiteCredentialsFromJSON(json["credentials"]),
  };
}

export function TestNetSuiteConnectionRequestToJSON(
  json: any,
): TestNetSuiteConnectionRequest {
  return TestNetSuiteConnectionRequestToJSONTyped(json, false);
}

export function TestNetSuiteConnectionRequestToJSONTyped(
  value?: TestNetSuiteConnectionRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    accountId: value["accountId"],
    credentials: NetSuiteCredentialsToJSON(value["credentials"]),
  };
}
